import { message } from "../message";
export const domainEvent = ({ messageId, occurredOn, name, aggregateId, }) => ({
    aggregateId,
    ...message({ messageId, occurredOn, name }),
});
